import { Turbo } from '@hotwired/turbo-rails'
import {
  confirm,
  alertError,
  alertSuccess,
  scheduleSuccess,
} from '../lib/dialogs'
import { controller } from '../lib/dom'

Turbo.config.forms.confirm = (text) => confirm(text)

// The webview makes every screen change a visit, and 500ms of silence in one reads as a freeze
Turbo.config.drive.progressBarDelay = 100

Turbo.StreamActions.alert_notice = function () {
  alertSuccess(this.templateContent.textContent)
}

Turbo.StreamActions.alert_alert = function () {
  alertError(this.templateContent.textContent)
}

Turbo.StreamActions.schedule_success = function () {
  const fragment = this.templateContent
  const tempDiv = document.createElement('div')
  tempDiv.appendChild(fragment.cloneNode(true))
  scheduleSuccess(tempDiv.innerHTML)
}

Turbo.StreamActions.close_modal = function () {
  controller(document.getElementById('modal'), 'modal').close()
}

Turbo.StreamActions.page_redirect = function () {
  document.location = this.getAttribute('target')
}

Turbo.StreamActions.refresh_frame = function () {
  const frame = document.getElementById(this.getAttribute('target'))
  if (!frame) return

  if (frame.src) {
    frame.reload()
  } else if (frame.dataset.refreshUrl) {
    frame.src = frame.dataset.refreshUrl
  }
}

Turbo.StreamActions.redirect_frame = function () {
  const frame = document.getElementById(this.getAttribute('target'))
  if (!frame) return

  const href = this.getAttribute('href')

  if (frame.getAttribute('src') === href) {
    frame.reload()
  } else {
    frame.src = href
  }
}
